import { type NotificationLanguage } from "@/features/notifications/model/notifications.types";

export function normalizeNotificationLanguage(value: string | null | undefined): NotificationLanguage | null {
  if (!value) return null;
  const normalized = value.trim().toLowerCase();
  if (normalized === "fr" || normalized.startsWith("fr-")) return "fr";
  if (normalized === "en" || normalized.startsWith("en-")) return "en";
  return null;
}
